<template>
  <el-dialog
    :visible="visible"
    width="600px"
    title="温馨提示"
    :show-close="true"
    :close-on-click-modal="false"
    :before-close="onClose"
    custom-class="publicity-notice-dialog"
    @close="onClose"
  >
    <div class="notice-panel">
      <img class="notice-icon" src="@/assets/cysuccess.png" alt="success" />
      <p class="notice-message">
        您的申报【{{ projectTitle }}】评价结果合格，现已进入公示期，请立即前往确认证书信息。
      </p>
      <div class="notice-actions">
        <el-button type="primary" class="notice-btn" @click="goToDeclarRecord">立即查阅</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'PublicityNotice',
  props: {
    // 需要确认的申报记录列表（publicity_status === 6）
    pendingList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    visible() {
      return this.pendingList.length > 0;
    },
    projectTitle() {
      const item = this.pendingList[0];
      if (!item) return '';
      if (item.content && item.content.info) {
        return item.content.info.projectNname || item.content.info.msg1 || item.content.info.name || item.content.info.title || item.award?.title || '';
      }
      return item.award?.title || '';
    },
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    goConfirm(item) {
      this.$emit('close');
      // 跳转到申报记录页，携带参数高亮该条记录
      this.$router.push({
        path: '/member/Declar_record',
        query: { name: '申报记录', highlight: item.id },
      });
    },
    goToDeclarRecord() {
      this.$emit('close');
      const item = this.pendingList[0];
      if (item && item.id) {
        this.$router.push({
          path: '/member/Publicity_confirm',
          query: { name: '公示期确认', log_id: item.id },
        });
        return;
      }
      this.$router.push({
        path: '/member/Declar_record',
        query: { name: '申报记录' },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.publicity-notice-dialog .el-dialog__body {
  padding: 0 !important;
  background: url('~@/assets/cybg.png') center/cover no-repeat;
}
.notice-panel {
  width: 560px;
  height: 320px;
  padding: 20px;
  padding-bottom: 36px;
  border-radius: 8px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow: hidden;
}
.notice-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.notice-title {
  font-size: 20px;
  color: #262626;
  font-weight: 400;
}
.notice-close {
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.notice-divider {
  width: calc(100% - 40px);
  height: 1px;
  background: #dddddd;
  margin-top: 8px;
}
.notice-icon {
  width: 76px;
  height: 70px;
  object-fit: contain;
}
.notice-message {
  margin-top: 24px;
  width: calc(100% - 140px);
  text-align: left;
  text-indent: 2em;
  font-size: 20px;
  color: #262626;
  line-height: 36px;
}
.notice-actions {
  margin-top: 30px;
}
.notice-btn {
  font-size: 18px;
  color: #fff;
  font-weight: bold;
  padding: 8px 48px;
  border-radius: 4px;
  background: #194abe;
  border: none;
}
.notice-panel::after {
  content: '';
  position: absolute;
  bottom: 36px;
  left: 0;
  right: 0;
  height: 0;
}
</style>
